import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating a view
import { allpayments } from 'models/allpayments'; // Importing allpayments model for data handling
import { devConfig } from 'config/config'; // Importing development configuration settings

/**
 * Class representing the advertising cashier view.
 * @extends JetView
 */
export default class tableAdvertisingCashierView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        // Retrieve the localization service and its translation function
        const _ = this.app.getService('locale')._;
        // Format date according to the application's date format configuration
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat);
        // Get the current user parameter from the request
        const cur_user = this.getParam('user', true);
        return {
            // Define the main view as a datatable
            view: 'datatable',
            // Apply CSS classes for styling
            css: 'webix_header_border webix_data_border',
            // Unique identifier for the datatable
            id: 'datatable4',
            // Enable row selection
            select: true,
            // Set minimum height for the datatable
            minHeight: 300,
            // Define the columns of the datatable
            columns: [
                {
                    // Column for rating with an icon for editing
                    id: 'rating',
                    header: '',
                    width: 50,
                    height: 25,
                    // Tooltip text for the column
                    tooltip: 'Editar',
                    // Hide the column based on permission configuration
                    hidden: !devConfig.getPermAction('permAdvertisingCashier', 'Edit'),
                    // CSS class for permission indication
                    css: 'prm-permAdvertisingCashier',
                    // Template function to render the edit icon
                    template: function (obj) {
                        return "<span class='webix_icon wxi-close edit'></span>";
                    },
                },
                // Column for ID with sorting enabled
                { id: 'Id', header: 'ID', width: 100, sort: 'int' },
                // Column for Name with localization support
                { id: 'Name', header: _('Nombre'), width: 300, sort: 'int' },
                // Column for Route with localization support
                { id: 'Route', header: _('Ruta'), width: 350, sort: 'int' },
                {
                    // Column for activation status with a combo editor
                    id: 'IsActivate',
                    header: _('Estado'),
                    editor: 'combo',
                    // Options for the combo editor
                    options: [
                        { id: 'A', value: _('Activado') },
                        { id: 'I', value: _('Inactivado') },
                    ],
                    width: 200,
                    sort: 'int',
                },
                // Column for Order with localization support
                { id: 'Order', header: _('Orden'), width: 300, sort: 'int' },
            ],
            // Event handler for click events on the edit icon
            onClick: {
                edit: function (euv, id) {
                    // Show the edit window for the selected item
                    $$('editwinAdvCashier').show();
                },
            },
            // Enable tooltips for the datatable
            tooltip: true,
            // Enable mathematical operations in the datatable
            math: true,
            // Set the data fetching strategy
            loadahead: devConfig.getDefaultDataFetch(),
            // Define the pager for pagination
            pager: 'pagerA',
            // Set the URL for fetching data from the API
            url: devConfig.geturlApi() + 'es/BetShop/GetAdvertising',
        }; // Placeholder for the configuration content
    }

    /**
     * Initializes the view and its components.
     * @param {Object} grid - The grid component to be initialized.
     */
    init(grid) {
        // Retrieve the localization service from the app
        const _ = this.app.getService('locale')._;
        var cur_user; // Variable to store the current user ID
        var url = grid.data.url; // URL for data loading in the grid

        // Event handler for sorting the grid
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            // Load the grid data after sorting
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + '&sort[' + by + ']=' + dir);
        });

        // Event handler for selecting an advertising cashier
        this.on(this.app, 'advertisingCashier:select', (id) => {
            grid.clearAll(); // Clear the grid data
            grid.load(url + '?FromId=' + id + '&'); // Load data for the selected cashier
            cur_user = id; // Set the current user ID
        });

        // Event handler for adding a new advertising cashier
        this.on(this.app, 'addAdvertisingCashier:button', (filter) => {
            popupAdd.show(); // Show the popup to add a new cashier
        });

        // Define the popup for adding a new advertising cashier
        var popupAdd = webix.ui({
            view: 'window',
            id: 'addwinAdvCashier',
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Añadir Publicidad Cajero') }, // Title of the popup
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Close the popup
                        },
                    },
                ],
            },
            position: 'center', // Center the popup on the screen
            modal: true, // Make the popup modal
            width: 5000, // Set the width of the popup
            body: {
                view: 'form',
                id: 'saveformCashier', // ID for the form in the popup
                elements: [
                    {
                        view: 'text',
                        name: 'Name', // Field for cashier name
                        label: _('Nombre'), // Label for the field
                        labelWidth: 150,
                        width: 300,
                        sort: 'int',
                    },
                    {
                        view: 'text',
                        name: 'Route', // Field for cashier route
                        label: _('Ruta'), // Label for the field
                        labelWidth: 150,
                        width: 300,
                        sort: 'int',
                    },
                    {
                        view: 'combo',
                        label: _('Estado'), // Field for cashier status
                        name: 'IsActivate',
                        labelWidth: 150,
                        width: 300,
                        options: [
                            { id: 'A', value: _('Activado') }, // Option for activated status
                            { id: 'I', value: _('Inactivado') }, // Option for deactivated status
                        ],
                    },
                    {
                        view: 'text',
                        name: 'Order', // Field for order
                        label: _('Orden'), // Label for the field
                        labelWidth: 150,
                        width: 300,
                        sort: 'int',
                        type: 'number', // Specify the type as number
                    },
                    {
                        cols: [
                            {
                                view: 'button',
                                value: _('Cancelar'), // Cancel button
                                click: function () {
                                    this.getTopParentView().hide(); // Close the popup
                                },
                            },
                            {
                                view: 'button',
                                type: 'form',
                                value: _('Guardar'), // Save button
                                click: function ($e) {
                                    var values = $$('saveformCashier').getValues(); // Get form values
                                    var vvthis = this; // Reference to the button
                                    webix
                                        .ajax()
                                        .headers({
                                            'Content-type': 'application/json', // Set content type for the request
                                        })
                                        .post(
                                            devConfig.geturlApi() + 'es/BetShop/SaveAdvertising', // API endpoint for saving advertising
                                            '{"FromId":"' +
                                                cur_user +
                                                '","Name":"' +
                                                values.Name +
                                                '","Route":"' +
                                                values.Route +
                                                '","IsActivate":"' +
                                                values.IsActivate +
                                                '","Order":"' +
                                                values.Order +
                                                '"}',
                                            {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message(_('Error! ')); // Show error message
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    webix.message(
                                                        _(
                                                            'Publicidad Cajero Añadida', // Show success message
                                                        ),
                                                    );
                                                    grid.clearAll(); // Clear the grid
                                                    grid.load(
                                                        url + '?FromId=' + cur_user + '&', // Reload grid data
                                                    );
                                                },
                                            },
                                        );
                                    $$('saveformCashier').clear(); // Clear the form
                                    this.getTopParentView().hide(); // Close the popup
                                },
                            },
                        ],
                    },
                ],
            },
        });

        // Define the popup for editing an existing advertising cashier
        var popupEdit = webix.ui({
            view: 'window',
            id: 'editwinAdvCashier',
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Editar Publicidad Cajero') }, // Title of the popup
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Close the popup
                        },
                    },
                ],
            },
            position: 'center', // Center the popup on the screen
            modal: true, // Make the popup modal
            width: 5000, // Set the width of the popup
            body: {
                view: 'form',
                id: 'editformAdvCashier', // ID for the form in the popup
                elements: [
                    {
                        view: 'text',
                        name: 'Id', // Field for cashier ID
                        label: 'ID', // Label for the field
                        labelWidth: 150,
                        width: 300,
                        disabled: true, // Disable the field for editing
                    },
                    {
                        view: 'text',
                        name: 'Name', // Field for cashier name
                        label: _('Nombre'), // Label for the field
                        labelWidth: 150,
                        width: 300,
                        sort: 'int',
                    },
                    {
                        view: 'text',
                        name: 'Route', // Field for cashier route
                        label: _('Ruta'), // Label for the field
                        labelWidth: 150,
                        width: 300,
                        sort: 'int',
                    },
                    {
                        view: 'combo',
                        label: _('Estado'), // Field for cashier status
                        name: 'IsActivate',
                        labelWidth: 150,
                        width: 300,
                        options: [
                            { id: 'A', value: _('Activado') }, // Option for activated status
                            { id: 'I', value: _('Inactivado') }, // Option for deactivated status
                        ],
                    },
                    {
                        view: 'text',
                        name: 'Order', // Field for order
                        label: _('Orden'), // Label for the field
                        labelWidth: 150,
                        width: 300,
                        sort: 'int',
                        type: 'number', // Specify the type as number
                    },
                    {
                        cols: [
                            {
                                view: 'button',
                                value: _('Cancelar'), // Cancel button
                                click: function () {
                                    this.getTopParentView().hide(); // Close the popup
                                },
                            },
                            {
                                view: 'button',
                                type: 'form',
                                value: _('Guardar'), // Save button
                                click: function ($e) {
                                    var values = $$('editformAdvCashier').getValues(); // Get form values
                                    var vvthis = this; // Reference to the button
                                    webix
                                        .ajax()
                                        .headers({
                                            'Content-type': 'application/json', // Set content type for the request
                                        })
                                        .post(
                                            devConfig.geturlApi() + 'es/BetShop/SaveAdvertising', // API endpoint for saving advertising
                                            '{"FromId":"' +
                                                cur_user +
                                                '","Id":"' +
                                                values.Id +
                                                '","Name":"' +
                                                values.Name +
                                                '","Route":"' +
                                                values.Route +
                                                '","IsActivate":"' +
                                                values.IsActivate +
                                                '","Order":"' +
                                                values.Order +
                                                '"}',
                                            {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message(_('Error! ')); // Show error message
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    webix.message(
                                                        _(
                                                            'Publicidad Cajero Añadida', // Show success message
                                                        ),
                                                    );
                                                    grid.clearAll(); // Clear the grid
                                                    grid.load(
                                                        url + '?FromId=' + cur_user + '&', // Reload grid data
                                                    );
                                                },
                                            },
                                        );
                                    $$('editformAdvCashier').clear(); // Clear the form
                                    this.getTopParentView().hide(); // Close the popup
                                },
                            },
                        ],
                    },
                ],
            },
        });

        // Event handler for item click in the grid
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Get the clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger an event with the item ID
        });

        // Event handler for selecting a player
        this.on(this.app, 'player:select', (Id) => {
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&FromId=' + Id, // Load grid data based on selected player ID
            );
        });

        // Event handler for double-clicking an item in the grid
        grid.attachEvent('onItemDblClick', function (id, e, node) {
            if (devConfig.getPermAction('permAdvertisingCashier', 'Edit')) {
                popupEdit.show(); // Show the edit popup if permission allows
            }
        });

        // Bind the edit form to the data table
        $$('editformAdvCashier').bind($$('datatable4')); // Placeholder for the initialization content
    }
}

// FILE DOCUMENTED
